const pollingSelector = ({ surcharge }) => {
  const {
    payPolling: { data },
  } = surcharge;

  return data || {};
};

export default pollingSelector;
